module.exports = __webpack_public_path__ + "static/media/IMG_9523.8c81de13.JPG";